import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_PREFERENCE = "GET_PREFERENCE";

export const service = async (data) => {
  const options: object = {
    url: `/api/utility/GetUserPreference/` + data.name,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_PREFERENCE, service, mock);
